export const FETCH_CALENDAR_APPOINTMENTS_REQUEST = "FETCH_CALENDAR_APPOINTMENTS_REQUEST";
export const FETCH_CALENDAR_APPOINTMENTS_SUCCESS = "FETCH_CALENDAR_APPOINTMENTS_SUCCESS";
export const FETCH_CALENDAR_APPOINTMENTS_FAILURE = "FETCH_CALENDAR_APPOINTMENTS_FAILURE";
